import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { AgitationSection } from '../components/AgitationSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { MethodSection } from '../components/MethodSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { PurchaseSection } from '../components/PurchaseSection';
import { UrgencySection } from '../components/UrgencySection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  return <div className="min-h-screen bg-[#faf6f0] font-opensans selection:bg-[#c9a96e] selection:text-black" data-id="element-233">
      <HeroSection data-id="element-234" />
      <ProblemSection data-id="element-235" />
      <AgitationSection data-id="element-236" />
      <SolutionSection data-id="element-237" />
      <ContentSection data-id="element-238" />
      <BenefitsSection data-id="element-239" />
      <MethodSection data-id="element-240" />
      <TestimonialsSection data-id="element-241" />
      <BonusSection data-id="element-242" />
      <OfferSection data-id="element-243" />
      <PurchaseSection data-id="element-244" />
      <UrgencySection data-id="element-245" />

      <SocialProofPopup data-id="element-246" />
    </div>;
}